module.exports = __webpack_public_path__ + "static/media/flower_necklace.1e519f53.png";